 

import React from 'react';

import { Icon } from '@gumtree/ui-library';
import { openPopup } from '@gumtree/ui-library/src/utils/browser-service';
import { trackGA4Event } from '@gumtree/shared/src/util/ga4-shared';
import { getLinkHostname } from '@gumtree/shared/src/util/ga4-bff';
import type { SocialShareLink } from '../../get-data/transform/share-links';
import { SharePanelLabel } from './style';

export default function ShareLink(props: SocialShareLink) {
    const { url, label, icon } = props;
    return (
        <a
            href={url}
            aria-haspopup="true"
            onClick={(e) => triggerOpenPopup(e, props)}
            data-q={icon}
        >
            <Icon type={icon} size="large" color="default" />
            <SharePanelLabel data-testid="share-label">{label}</SharePanelLabel>
        </a>
    );
}

ShareLink.defaultProps = {
    noPopup: false,
    url: '',
};

export type Props = SocialShareLink;

function triggerOpenPopup(e: React.MouseEvent, { noPopup, url, label }: SocialShareLink) {
    if (!noPopup) {
        e.preventDefault();
        trackGA4Event<GA4.ClickToShareListing>({
            event: 'click_to_share_listing',
            linkDomain: getLinkHostname(url),
            linkText: label,
            linkURL: url,
        });
        openPopup({ url });
    }
}
